




















































































































import { ToastOptions } from "@abaco/web-common/src/app/Toasted";
import { uniqueId } from "lodash";
import { Upload } from "tus-js-client";
import { TranslateResult } from "vue-i18n";
import { Component, Inject, Prop, Ref, Vue } from "vue-property-decorator";
import MaltaModule, { MODULE_ID } from "../../index";
import { API_PATH } from "../../models/Constants";
import { FileModel } from "../../models/FileModel";
import TusButton, { TusFile } from "../private/forms/TusButton.vue";

@Component({
    components: {
        TusButton
    }
})
export default class ProjectProposalUploadFiles extends Vue {
    @Inject() toast!: (message: string, options?: ToastOptions) => void;
    @Ref("input") input!: HTMLInputElement;
    @Ref("form") form!: HTMLFormElement;
    @Inject() i18n!: (key: string, values?: unknown) => TranslateResult;
    @Inject(MODULE_ID) maltaModule!: MaltaModule;
    @Prop({ type: Object, required: true }) item!: FileModel;
    @Prop({ type: Boolean, default: false }) isError!: boolean;
    @Prop({ type: Boolean, default: false }) isRequired!: boolean;
    @Prop({ type: Boolean, default: false }) isReadOnly!: boolean;
    @Prop({ type: Boolean, default: false }) excludePdfs!: boolean;
    @Prop({ type: Boolean, default: false }) excludeImages!: boolean;
    @Prop({ type: Boolean, default: false }) excludeWords!: boolean;
    @Prop({ type: Boolean, default: false }) excludeExcels!: boolean;
    @Prop({ type: Boolean, default: false }) excludeZips!: boolean;

    get subjectId(): string {
        return this.$route.params.subjectId;
    }

    get itemsLength(): number {
        return this.item.file_ids.length + this.item.upload_urls.length;
    }

    get disabled() {
        return this.onProgress || this.itemsLength >= this.item.max_files_upload;
    }

    files: TusFile[] = [];

    openModal = false;

    mounted() {
        for (const file of this.item.file_ids) {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            this.maltaModule.projectProposalApi.getFiles(this.subjectId, file).then(([resp, _err]) => {
                if (resp && resp.data) {
                    const blob = new Blob([new Uint8Array(resp.data)], { type: resp.contentType });
                    const src = URL.createObjectURL(blob);
                    if (this.imagesMime.includes(resp.contentType)) {
                        const image = new Image();
                        image.src = src;
                        image.onload = () => {
                            this.files.push({
                                id: uniqueId("tus-instance-"),
                                fileId: file,
                                type: blob.type,
                                src,
                                filename: resp.filename,
                                width: image.width,
                                height: image.height,
                                success: false,
                                paused: false,
                                progress: false
                            });
                        };
                    } else {
                        this.files.push({
                            id: uniqueId("tus-instance-"),
                            fileId: file,
                            type: blob.type,
                            src,
                            filename: resp.filename,
                            success: false,
                            paused: false,
                            progress: false
                        });
                    }
                }
            });
        }
    }

    get imagesMime(): string[] {
        if (this.excludeImages) return [];
        return ["image/png", "image/gif", "image/jpeg", "image/webp"];
    }

    get pdfsMime(): string[] {
        if (this.excludePdfs) return [];
        return ["application/pdf"];
    }

    get wordsMime(): string[] {
        if (this.excludeWords) return [];
        return [
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            "application/vnd.oasis.opendocument.text"
        ];
    }

    get excelsMime(): string[] {
        if (this.excludeExcels) return [];
        return [
            "application/vnd.ms-excel",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "application/vnd.oasis.opendocument.spreadsheet"
        ];
    }

    get zipsMime(): string[] {
        if (this.excludeZips) return [];
        return ["application/octet-stream", "application/zip", "application/x-zip", "application/x-zip-compressed"];
    }

    get accept(): string {
        const values: string[] = [
            ...this.imagesMime,
            ...this.pdfsMime,
            ...this.wordsMime,
            ...this.excelsMime,
            ...this.zipsMime
        ];
        return values.join(",");
    }

    onClose() {
        this.openModal = false;
        this.$emit("close", false);
    }

    onCancel() {
        this.openModal = false;
        this.$emit("cancel", false);
    }

    deleteFile(index: number, item: TusFile) {
        this.files.splice(index, 1);
        this.item.file_ids = this.item.file_ids.filter(e => e !== item.fileId);
    }

    deleteTusFile(index: number, url?: string) {
        this.files.splice(index, 1);
        this.item.upload_urls = this.item.upload_urls.filter(e => e !== url);
    }

    successFile(url: string) {
        const upload_urls = new Set(this.item.upload_urls);
        upload_urls.add(url);
        this.item.upload_urls = [...upload_urls];
    }

    async onFile(file: File) {
        if (!this.accept.includes(file.type)) {
            this.toast(this.i18n("file-type-not-supported-errors").toString(), { type: "error" });
            return;
        }
        const fileReader = new FileReader();
        fileReader.onload = async e => {
            if (e.target?.result) {
                // const blob = new Blob([e.target.result as string], {type: file.type});
                const token = await this.maltaModule.tokensResources.getSSOToken(false);
                const uploader = new Upload(file, {
                    endpoint: `${API_PATH}/upload/`,
                    chunkSize: process.env.VUE_APP_FILE_CHUNK_SIZE_IN_KB
                        ? +process.env.VUE_APP_FILE_CHUNK_SIZE_IN_KB
                        : Infinity,
                    metadata: {
                        filename: file.name,
                        filetype: file.type
                    },
                    headers: {
                        Authorization: `JWT ${token}`
                    }
                });

                const [first] = await uploader.findPreviousUploads();
                if (first) {
                    uploader.resumeFromPreviousUpload(first);
                }
                uploader.start();

                if (this.imagesMime.includes(file.type)) {
                    const image = new Image();
                    image.src = e.target.result as string; //URL.createObjectURL(blob);
                    image.onload = () => {
                        this.files.unshift({
                            id: uniqueId("tus-instance-"),
                            file,
                            uploader,
                            src: image.src,
                            type: file.type,
                            filename: file.name,
                            width: image.width,
                            height: image.height,
                            success: false,
                            paused: false,
                            progress: false
                        });
                    };
                } else {
                    this.files.unshift({
                        id: uniqueId("tus-instance-"),
                        file,
                        uploader,
                        type: file.type,
                        src: e.target.result as string,
                        filename: file.name,
                        success: false,
                        paused: false,
                        progress: false
                    });
                }
            }
        };
        fileReader.readAsDataURL(file);
    }

    get onProgress() {
        return this.files.some(e => e.progress);
    }

    async uploadFileOnDrop(e: DragEvent) {
        if (
            e.dataTransfer &&
            !this.onProgress &&
            e.dataTransfer.files &&
            e.dataTransfer.files.length + this.itemsLength <= this.item.max_files_upload
        ) {
            for (const file of e.dataTransfer.files) {
                await this.onFile(file);
            }
        } else {
            this.toast(this.i18n("too-many-files-errors").toString(), { type: "error" });
        }
    }

    async uploadFile(e: Event) {
        const input = e.target as HTMLInputElement;
        if (input.files) {
            if (input.files.length + this.itemsLength > this.item.max_files_upload) {
                this.toast(this.i18n("too-many-files-errors").toString(), { type: "error" });
                return;
            }
            for (const file of input.files) {
                await this.onFile(file);
            }
        }

        this.form.reset();
    }
}
